import type {AddCommentEditorFooterState} from '@github-ui/diff-lines/add-comment-editor'
import {
  isCopilotCodeReviewThread,
  type ResolutionReasonType,
  type Thread,
} from '@github-ui/diff-lines/conversation-types'
import {isFeatureEnabled} from '@github-ui/feature-flags'
import {use} from 'react'

import {CommentsContext} from './CommentsContext'
import {ThreadResolveActions} from './ThreadResolveActions'
import {threadLabel} from './utils/thread-label'

/**
 * The Resolve controls for a thread's reply composer. On its own (the collapsed reply row) it is a plain Resolve
 * button. Given the editor's footer state it becomes Reply and resolve once there is a draft.
 */
export function InlineThreadResolveActions({
  thread,
  busy,
  onResolve,
  footer,
  disabled,
}: {
  thread: Thread
  busy: boolean
  onResolve: (reason?: ResolutionReasonType) => void
  footer?: AddCommentEditorFooterState
  // CommentBox injects this into the actions it renders in the editor's footer.
  disabled?: boolean
}) {
  const {contextualCommentControls} = use(CommentsContext)

  return (
    <ThreadResolveActions
      onResolve={onResolve}
      showReasons={isFeatureEnabled('thread_resolution_reason') && isCopilotCodeReviewThread(thread)}
      contextLabel={contextualCommentControls ? threadLabel(thread) : undefined}
      busy={busy}
      disabled={disabled}
      onReplyAndResolve={footer?.canReplyAndResolve && footer.hasDraft ? footer.onReplyAndResolve : undefined}
      replyAndResolveDisabled={footer?.replyAndResolveDisabled}
    />
  )
}
